import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="columns">
          <div className="column has-text-centered">
            <a target="_blank" href="https://soilhealthbenchmarks.eu/">
              <img src={process.env.PUBLIC_URL + '/logos/SHB_logo_main_mono.png'} alt="Soil Health Benchmarks Logo" />
            </a>
          </div> 
          <div className="column has-text-centered">
            <a target="_blank" href="https://cordis.europa.eu/project/id/101091010">
              <img src={process.env.PUBLIC_URL + '/logos/EN_FundedbytheEU_RGB_NEG.png'} alt="Funded by the EU" />
            </a>
          </div>
        </div>
        <div className="content has-text-centered">
          <p>Website developed by the <a target="_blank" href="https://ecoenvai.ijs.si" >EcoEnvAI</a> team at the <a target="_blank" href="https://www.ijs.si">Jožef Stefan Institute</a> in Ljubljana, Slovenia</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
